import { render } from "./PrimitivePolygon.vue?vue&type=template&id=76f7a536"
import script from "./PrimitivePolygon.vue?vue&type=script&lang=js"
export * from "./PrimitivePolygon.vue?vue&type=script&lang=js"

import exportComponent from "/builds/tumeda/flui3d-mold/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__